import style from "../../assets/scss/common/header.module.scss";

interface Props {
  couponCount: number;
  organVoucherCount: number;
  userVoucherCount: number;
}

export function CouponVoucherStatus({ couponCount, organVoucherCount, userVoucherCount }: Props) {
  return (
    <ul className={style.vouchers}>
      <li className={style.anItem}>
        <span className={style.label}>보유쿠폰</span>
        <span className={style.content}>{couponCount ?? 0} 장</span>
      </li>
      <li className={style.anItem}>
        <span className={style.label}>소속이용권</span>
        <span className={style.content}>{organVoucherCount ?? 0} 매</span>
      </li>
      <li className={style.anItem}>
        <span className={style.label}>검사이용권</span>
        <span className={style.content}>{userVoucherCount ?? 0} 매</span>
      </li>
    </ul>
  );
}
